import { container } from "assets/jss/material-kit-react.js";

const signupPageStyle = {
  container: {
    ...container,
    position: "relative",
    paddingTop: "0px",
    color: "#FFFFFF",
    paddingBottom: "0px",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  myBody:{
    overscrollBehaviorY: 'contain',
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  pageHeader: {
    minHeight: "100vh",
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "0",
    padding: "0",
    border: "0",
    alignItems: "center",
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)"
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""'
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF"
    },
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%"
    }
  },
  form: {
    margin: "0"
  },
  myImgProds: {
      height: "80px",
      width: "80px",
      marginRight: "10px",
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "0px",
    marginRight: "0px",
    marginTop: "-40px",
    marginBottom: "0px",
    height: "250px",    
    background: "none",
    backgroundColor: "#fff",
    padding: "0px",
  },
  socialIcons: {
    maxWidth: "24px",
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px"
  },
  divider: {
    marginTop: "30px",
    marginBottom: "0px",
    textAlign: "center"
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0"
  },
  inputIconsColor: {
    color: "#495057"
  },
  myAvatarImg: {
    width: '100%',
    height: 'unset',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE 11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000,
  },
  separator: {
    width: "100%",
    height: "1px",
    marginRight: "30px",
    backgroundImage: "radial-gradient(#CCC, #FFF), radial-gradient(#CCC, #FFF)",
    backgroundPosition: "0, 100%, 0, 100%",
  },
  separatorMenu: {
    width: "100%",
    height: "2px",
    marginRight: "30px",
    backgroundImage: "radial-gradient(#F00, #FFF), radial-gradient(#F00, #FFF)",
    backgroundPosition: "0, 100%, 0, 100%",
  },
  loginForm: {
    width: "70%",
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '80px',
    marginTop: '80px',
    maxWidth: '444px',
  },
  addEndForm: {
    width: "85%",
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '80px',
    maxWidth: '444px',
  },
  usuarioForm: {
    width: "90%",
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '80px',
    marginTop: '80px',
  },
  paper: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: '2px',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  submit: {
    margin: '6px 0px 4px',
    fontSize: '15px',
    fontWeight: '400',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  facebookBtn: {
    backgroundColor: '#3b5998',
    margin: '6px 0px 4px',
    fontSize: '15px',
    width: '100%',
    color: '#fff',
    fontWeight: '400',
    height: '45px',
  },
  enderecoInputs : {
    [`& fieldset`]: {
      borderRadius: '14px',
    },
    [`& .MuiSelect-select`]: {
      borderRadius: '14px',
    },
    marginTop: '12px',
    marginBottom: '12px',
  },
  myTooltip: {
    fontSize: '18px',
    width: '450px',
  }
};

export default signupPageStyle;
